import React from 'react';
import PageWrapper from '../../PageWrapper/PageWrapper';

function withPageWrapper<T extends React.PropsWithChildren<{}>>(
  WrappedPage: React.ComponentType<T>
): React.ComponentType<T> {
  function ComponentWithPageWrapper(props: T): React.ReactElement {
    return (
      <PageWrapper>
        <WrappedPage {...props} />
      </PageWrapper>
    );
  }

  return ComponentWithPageWrapper;
}

export default withPageWrapper;
